/**
 * @description Diagram events const
 */
export const DIAGRAM_EVENTS = {
    DRAG_OVER: "DRAG_OVER",
    DROP: "DROP",
    DRAG_LEAVE: "DRAG_LEAVE",
    MOUSE_LEAVE: "MOUSE_LEAVE",
    MOUSE_ENTER: "MOUSE_ENTER",
    MOUSE_UP_WINDOW: "MOUSE_UP_WINDOW",
    CLICK: "CLICK",
    MOUSE_DOWN: "MOUSE_DOWN",
    MOUSE_UP: "MOUSE_UP",
    MOUSE_WHEEL: "MOUSE_WHEEL",
    MOUSE_MOVE: "MOUSE_MOVE",
    KEYDOWN: "KEY_DOWN",
    MOUSE_DBL_CLICK: "MOUSE_DBL_CLICK"
};
